import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { WhatItIs } from './components/WhatItIs';
import { UseCases } from './components/UseCases';
import { ComparisonTable } from './components/ComparisonTable';
import { OneLiners } from './components/OneLiners';
import { HowToGetIt } from './components/HowToGetIt';
import { WhoShouldUse } from './components/WhoShouldUse';
import { Future } from './components/Future';
import { Footer } from './components/Footer';
export function App() {
  return <div className="bg-[#111] text-white min-h-screen w-full" data-id="element-0">
      <Header data-id="element-1" />
      <main className="w-full" data-id="element-2">
        <Hero data-id="element-3" />
        <WhatItIs data-id="element-4" />
        <UseCases data-id="element-5" />
        <ComparisonTable data-id="element-6" />
        <OneLiners data-id="element-7" />
        <HowToGetIt data-id="element-8" />
        <WhoShouldUse data-id="element-9" />
        <Future data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}